import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, vModelText as _vModelText, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-918664be"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "error"
}
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "account" }, " Account Id: ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: "",
  hidden: ""
}, "mandatory", -1))
const _hoisted_5 = ["value"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "market" }, " Market: ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: "",
  hidden: ""
}, "mandatory", -1))
const _hoisted_8 = ["value"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "currency" }, " Currency: ", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "Market Default", -1))
const _hoisted_11 = ["value"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "transfer-type" }, " Transfer Type Id: ", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: "",
  hidden: ""
}, "mandatory", -1))
const _hoisted_14 = ["value"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "item-type" }, " Item Type Id: ", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: "",
  hidden: ""
}, "mandatory", -1))
const _hoisted_17 = ["value"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "item-category" }, " Item Category: ", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: "",
  hidden: ""
}, "mandatory", -1))
const _hoisted_20 = ["value"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "assigned-to" }, " Assigned To: ", -1))
const _hoisted_22 = ["value"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "category-period" }, " Category Period: ", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "target-date" }, " Target Date: ", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "value-date" }, " Value Date: ", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "transaction-id" }, " Transaction Id: ", -1))
const _hoisted_27 = ["pattern"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "transfer-info" }, " Transfer Info: ", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "payment-advice-ref" }, " Payment Advice Reference: ", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "payment-advice-ref" }, " Payment Reference: ", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "invoice-id" }, " Invoice Id: ", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "credit-note-id" }, " Credit Note Id: ", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "contract-id" }, " Contract Id: ", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "amount" }, " Amount: ", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "confirm-button",
  type: "submit"
}, "Confirm", -1))

import '@vuepic/vue-datepicker/dist/main.css';
import {ref,computed,onMounted,watch} from 'vue';
import DatePicker from '@vuepic/vue-datepicker';
import Popup from '../Popup.vue';
import Spinner from '../Spinner.vue';
import CurrencyInput from '../CurrencyInput.vue';
import ClearableSelect from '../ClearableSelect.vue';
import PeriodSelector from '../PeriodSelector.vue';
import useSpinnerPopup from '@/services/composables/SpinnerPopup';
import ILedgerTransactionRequest from '@/Interfaces/Ledgering/ILedgerTransactionRequest';
import ILedgerTransactionOptions from '@/Interfaces/Ledgering/ILedgerTransactionOptions';
import { ledgerTransactionOptions, ledgerTransactions } from '@/services/network';
import { MarketSelection, marketSelection, MarketCurrency } from '@/services/helpers/Helper';
import LedgerTransaction from '@/models/Ledgering/LedgerTransaction';
import ILedgerTransaction from '@/Interfaces/Ledgering/ILedgerTransaction';
import DateIgnoreTime from '@/types/DateIgnoreTime';
import useNotifierWithErrFormatter from '@/services/composables/NotifierWithErrFormatter';


export default /*#__PURE__*/_defineComponent({
  __name: 'LedgerTransactionForm',
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue", "submit"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;
const emits = __emit;
__expose({
    assignTemplate
});
const displayingForm = computed({
    get(){
        return props.modelValue;
    },
    set(val: boolean) {
        emits('update:modelValue', val);
    }
});
const error = ref();
const working = ref(false);
let promise: Promise<ILedgerTransactionOptions> | undefined = undefined;
const options = ref<ILedgerTransactionOptions>();
const loading = computed(()=>!!error.value||!options.value);
const updated = ref(true);
const preFilledId = ref('');
const transIdPattern = computed(()=>`^(${preFilledId.value}0|)$`);
//const loading = true;
const transaction = ref(getDefaultTransactionRequest());
onMounted(refreshOptions);
watch(displayingForm, (val)=>{
    if (val) loadOptionsIfNeeded();
    else {
        transaction.value = getDefaultTransactionRequest();
        preFilledId.value = '';
    }
});
function getDefaultTransactionRequest(): Partial<ILedgerTransactionRequest> {
    return {
        accountId: '',
        market: marketSelection.value,
        currency: null,
        transferTypeId: '',
        itemType: '',
        itemCategory: '',
    };
}
function loadOptionsIfNeeded() {
    console.trace('loadOptionsIfNeeded', options.value);
    if (!options.value && !promise) refreshOptions();
}
async function refreshOptionsInner() {
        const optionRes = await ledgerTransactionOptions.get();
        return optionRes.data;
}
async function refreshOptions() {
    try {
        promise = refreshOptionsInner();
        error.value = undefined;
        options.value = await promise;
    } catch(e: unknown) {
        error.value = e;
    } finally {
        promise = undefined;
    }
}
function emptyStringToNull(nullable?: string | null) {
    return nullable ? nullable : null;
}
async function submit(transaction: ILedgerTransactionRequest) {
    const closeSpinner = useSpinnerPopup().show();
    try {
        if (!updated.value) {
            useNotifierWithErrFormatter().warn({
                msg: 'No value has been updated'
            });
            return;
        }
        const res = await ledgerTransactions.post(transaction);
        const transactionRaw: ILedgerTransaction = {
            paymentId: res.data.paymentId,
            transactionId: transaction.transactionId ? +transaction.transactionId : null,
            accountId: transaction.accountId,
            valueDate: transaction.valueDate,
            targetDate: transaction.targetDate,
            amount: +transaction.amount,
            market: transaction.market,
            currency: transaction.currency ?? MarketCurrency[transaction.market],
            paymentAdviceReference: transaction.paymentAdviceReference,
            paymentReference: transaction.paymentReference,
            transferTypeId: transaction.transferTypeId,
            itemType: transaction.itemType,
            itemCategory: transaction.itemCategory,
            categoryPeriod: transaction.categoryPeriod,
            invoiceId: transaction.invoiceId,
            creditNoteId: transaction.creditNoteId,
            contractId: transaction.contractId,
            assignedTo: transaction.assignedTo,
            transferInfo: transaction.transferInfo
        }
        onPostSuccess();
        emits('submit', new LedgerTransaction(transactionRaw));
    } catch (error) {
        useNotifierWithErrFormatter().error({
            errorType: 'Submitting Ledger Transaction',
            error
        });
    } finally {
        closeSpinner();
    }
}
async function onSubmit() {
    if (working.value) return;
    working.value = true;
    /**
     * cover for stuff not covered by input checks
     */
    function validateRequest(obj: Partial<ILedgerTransactionRequest>): obj is ILedgerTransactionRequest {
        let result = true;
        obj.transactionId = emptyStringToNull(obj.transactionId);
        obj.valueDate = new DateIgnoreTime(obj.valueDate);
        obj.targetDate = new DateIgnoreTime(obj.targetDate!); // can never be undefined since it's called by onSubmit
        obj.paymentAdviceReference = emptyStringToNull(obj.paymentAdviceReference);
        obj.paymentReference = emptyStringToNull(obj.paymentReference);
        obj.invoiceId = emptyStringToNull(obj.invoiceId);
        obj.creditNoteId = emptyStringToNull(obj.creditNoteId);
        obj.contractId = emptyStringToNull(obj.contractId);
        return result;
    }
    if (validateRequest(transaction.value)) submit(transaction.value);
    working.value = false;
}
function onPostSuccess() {
    useNotifierWithErrFormatter().success({
        msg: 'Transaction successfully registered.'
    });
    displayingForm.value = false;
    updated.value = true;
    transaction.value = getDefaultTransactionRequest();
}
function assignTemplate(template: ILedgerTransaction) {
    updated.value = false;
    transaction.value = Object.assign(getDefaultTransactionRequest(), template);
    if (typeof transaction.value.amount === 'number') transaction.value.amount = `${transaction.value.amount}`;
    preFilledId.value = transaction.value.transactionId?`${transaction.value.transactionId}|`:'';
}
function onUpdated() {
    updated.value = true;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Popup, {
    modelValue: displayingForm.value,
    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((displayingForm).value = $event)),
    title: "Create New Ledger Transaction",
    hasClose: ""
  }, {
    contents: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["form-container", { 'hide-scroll':loading.value }])
      }, [
        (error.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, "Error loading options"))
          : (loading.value)
            ? (_openBlock(), _createBlock(Spinner, { key: 1 }, {
                default: _withCtx(() => [
                  _createTextVNode("Loading options")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
        _createElementVNode("form", {
          class: _normalizeClass([{hidden:loading.value}, "two-column"]),
          onSubmit: _withModifiers(onSubmit, ["prevent"])
        }, [
          _hoisted_3,
          _withDirectives(_createElementVNode("select", {
            id: "account",
            onChange: onUpdated,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((transaction.value.accountId) = $event)),
            required: ""
          }, [
            _hoisted_4,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value?.accountIds, (id) => {
              return (_openBlock(), _createElementBlock("option", {
                value: id,
                key: id
              }, _toDisplayString(id), 9, _hoisted_5))
            }), 128))
          ], 544), [
            [_vModelSelect, transaction.value.accountId]
          ]),
          _hoisted_6,
          _withDirectives(_createElementVNode("select", {
            id: "market",
            onChange: onUpdated,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((transaction.value.market) = $event)),
            required: ""
          }, [
            _hoisted_7,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(_unref(MarketSelection)), ([k,v]) => {
              return (_openBlock(), _createElementBlock("option", {
                value: k,
                key: k
              }, _toDisplayString(v), 9, _hoisted_8))
            }), 128))
          ], 544), [
            [_vModelSelect, transaction.value.market]
          ]),
          _hoisted_9,
          _withDirectives(_createElementVNode("select", {
            id: "currency",
            onChange: onUpdated,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((transaction.value.currency) = $event)),
            required: ""
          }, [
            _hoisted_10,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value?.marketCurrencies, (id) => {
              return (_openBlock(), _createElementBlock("option", {
                value: id,
                key: id
              }, _toDisplayString(id), 9, _hoisted_11))
            }), 128))
          ], 544), [
            [_vModelSelect, transaction.value.currency]
          ]),
          _hoisted_12,
          _withDirectives(_createElementVNode("select", {
            id: "transfer-type",
            onChange: onUpdated,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((transaction.value.transferTypeId) = $event)),
            required: ""
          }, [
            _hoisted_13,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value?.transferTypes, (id) => {
              return (_openBlock(), _createElementBlock("option", {
                value: id,
                key: id
              }, _toDisplayString(id), 9, _hoisted_14))
            }), 128))
          ], 544), [
            [_vModelSelect, transaction.value.transferTypeId]
          ]),
          _hoisted_15,
          _withDirectives(_createElementVNode("select", {
            id: "item-type",
            onChange: onUpdated,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((transaction.value.itemType) = $event)),
            required: ""
          }, [
            _hoisted_16,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value?.itemTypes, (id) => {
              return (_openBlock(), _createElementBlock("option", {
                value: id,
                key: id
              }, _toDisplayString(id), 9, _hoisted_17))
            }), 128))
          ], 544), [
            [_vModelSelect, transaction.value.itemType]
          ]),
          _hoisted_18,
          _withDirectives(_createElementVNode("select", {
            id: "item-category",
            onChange: onUpdated,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((transaction.value.itemCategory) = $event)),
            required: ""
          }, [
            _hoisted_19,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value?.itemCategories, (id) => {
              return (_openBlock(), _createElementBlock("option", {
                value: id,
                key: id
              }, _toDisplayString(id), 9, _hoisted_20))
            }), 128))
          ], 544), [
            [_vModelSelect, transaction.value.itemCategory]
          ]),
          _hoisted_21,
          _createVNode(ClearableSelect, {
            id: "assigned-to",
            "onUpdate:modelValue": [
              onUpdated,
              _cache[6] || (_cache[6] = ($event: any) => ((transaction.value.assignedTo) = $event))
            ],
            modelValue: transaction.value.assignedTo
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value?.contractOwnerIds, (id) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: id,
                  key: id
                }, _toDisplayString(id), 9, _hoisted_22))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _hoisted_23,
          _createVNode(PeriodSelector, {
            id: "category-period",
            class: "input",
            hasNullSelector: "",
            nullSelectorName: "NULL",
            onChange: onUpdated,
            modelValue: transaction.value.categoryPeriod,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((transaction.value.categoryPeriod) = $event))
          }, null, 8, ["modelValue"]),
          _hoisted_24,
          _createVNode(_unref(DatePicker), {
            class: "input",
            id: "target-date",
            "onUpdate:modelValue": [
              onUpdated,
              _cache[8] || (_cache[8] = ($event: any) => ((transaction.value.targetDate) = $event))
            ],
            modelValue: transaction.value.targetDate,
            "enable-time-picker": false,
            teleport: true,
            required: "",
            placeholder: "mandatory"
          }, null, 8, ["modelValue"]),
          _hoisted_25,
          _createVNode(_unref(DatePicker), {
            class: "input",
            id: "value-date",
            "onUpdate:modelValue": [
              onUpdated,
              _cache[9] || (_cache[9] = ($event: any) => ((transaction.value.valueDate) = $event))
            ],
            modelValue: transaction.value.valueDate,
            "enable-time-picker": false,
            teleport: true
          }, null, 8, ["modelValue"]),
          _hoisted_26,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "transfer-info",
            onInput: onUpdated,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((transaction.value.transactionId) = $event)),
            pattern: transIdPattern.value,
            placeholder: "null"
          }, null, 40, _hoisted_27), [
            [_vModelText, transaction.value.transactionId]
          ]),
          _hoisted_28,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "transfer-info",
            onInput: onUpdated,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((transaction.value.transferInfo) = $event))
          }, null, 544), [
            [_vModelText, transaction.value.transferInfo]
          ]),
          _hoisted_29,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "payment-advice-ref",
            onInput: onUpdated,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((transaction.value.paymentAdviceReference) = $event))
          }, null, 544), [
            [_vModelText, transaction.value.paymentAdviceReference]
          ]),
          _hoisted_30,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "payment-ref",
            onInput: onUpdated,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((transaction.value.paymentReference) = $event))
          }, null, 544), [
            [_vModelText, transaction.value.paymentReference]
          ]),
          _hoisted_31,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "invoice-id",
            onInput: onUpdated,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((transaction.value.invoiceId) = $event))
          }, null, 544), [
            [_vModelText, transaction.value.invoiceId]
          ]),
          _hoisted_32,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "credit-note-id",
            onInput: onUpdated,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((transaction.value.creditNoteId) = $event))
          }, null, 544), [
            [_vModelText, transaction.value.creditNoteId]
          ]),
          _hoisted_33,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "contract-id",
            onInput: onUpdated,
            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((transaction.value.contractId) = $event))
          }, null, 544), [
            [_vModelText, transaction.value.contractId]
          ]),
          _hoisted_34,
          _createVNode(CurrencyInput, {
            modelValue: transaction.value.amount,
            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((transaction.value.amount) = $event)),
            onInput: onUpdated,
            placeholder: "mandatory",
            currency: transaction.value.currency ?? _unref(MarketCurrency)[transaction.value.market ?? ''],
            step: 0.0001,
            required: ""
          }, null, 8, ["modelValue", "currency"]),
          _hoisted_35
        ], 42, _hoisted_2)
      ], 2)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})